import BaseObjectDirective from './BaseObjectDirective';

/**
 * AsfAudioObjectCtrl - Controller for handling audio objects in the CMS.
 * Extends BaseObjectDirective.
 */
export class AsfAudioObjectCtrl extends BaseObjectDirective {
    /**
     * Constructor for AsfAudioObjectCtrl.
     * @param {Object} $scope - Angular scope.
     * @param {Object} $injector - Angular injector service.
     * @param {Object} $uibModal - Angular UI Bootstrap modal service.
     * @param {Object} $rootScope - Angular root scope.
     * @param {Object} $routeParams - Angular route parameters.
     * @param {Object} TaskDataService - Service for task data operations.
     * @param {Object} $signals - Signal service for event handling.
     * @param {Object} $q - Angular promise service.
     * @param {Object} $timeout - Angular timeout service.
     * @param {Object} SheetLoadedService - Service for handling sheet loading.
     */
    constructor($scope, $injector, $uibModal, $rootScope, $routeParams, TaskDataService, $signals, $q, $timeout, SheetLoadedService) {
        super($injector, $scope);                

        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.$routeParams = $routeParams;
        this.$uibModal = $uibModal;
        this.TaskDataService = TaskDataService;
        this.$signals = $signals;
        this.$q = $q;
        this.$timeout = $timeout;
        this.SheetLoadedService = SheetLoadedService;

        $scope.isCMS = $rootScope.isCMS;
        $scope.prefsMode = false;
        $scope.hasBrowseImage = true;
        $scope.hasBrowseSubtitle = true;
        $scope.hasAudioObjectBackgroundImages = $scope.contentObject.getContentReference() ? true : false;
        $scope.selectImage = false;

        $scope.audioObject = undefined;
        $scope.mediaObject = undefined;

        $scope.taskuuid = $routeParams.taskUUID;

        // Decide how many columns and offer different display sizes
        var big_container = $scope.$parent.rows ? $scope.$parent.rows[$scope.$parent.rowKey].cols.length == 1 : true;
        

        /**
         * Watches for changes in contentObject and updates related properties.
         * @param {string} uuid - UUID of the content object.
         */
        $timeout(function() {           
            $scope.audioObject = $scope.contentObject.getContentReference(false);

            if ($scope.audioObject) {
                $scope.subtitleOnPlay = $scope.contentObject.getPreferences().showSubtitleOnPlay;
                if ($scope.contentObject.getContent() != '') {
                    $scope.subtitle = TaskDataService.fetchContext().read($scope.contentObject.getContent());
                    $scope.removeSubtitle = true;
                } else {
                    $scope.subtitle = undefined;
                    $scope.removeSubtitle = false;
                }
                if (typeof $scope.contentObject.getAttachement() !== 'undefined' && Object.keys($scope.contentObject.getAttachement()).length !==0) {
                    $scope.bgImage = TaskDataService.fetchContext().read($scope.contentObject.getAttachement());
                    $scope.removeBgImage = true;
                } else {
                    $scope.bgImage = undefined;
                    $scope.removeBgImage = false;
                }
            }
        }, 50);


        /**
         * Handles the click event for media browse button.
         */
        $scope.onMediaBrowseButtonClick = function() {
            $scope.openMediaModal('audio');
        };

        /**
         * Calculates the height based on the width and maximum width constraints.
         * @param {number} width - Original width of the media.
         * @param {number} height - Original height of the media.
         * @returns {number} - Adjusted height.
         */
        $scope.calcHeight = function (width, height) {
            var maxWidth = $scope.$parent.$parent.size == 50 ? 415 : 919;
            if(width > maxWidth){
                var ratio = maxWidth / width;   // get ratio for scaling image
                height = height * ratio; // Reset height to match scaled image
                return height;
            } else {
                var newRatio = maxWidth / width;   // get ratio for scaling image
                height = height * newRatio; // Reset height to match scaled image
                return height;
            }
        };

        /**
         * Calculates the width based on the width and maximum width constraints.
         * @param {number} width - Original width of the media.
         * @param {number} height - Original height of the media.
         * @returns {number|string} - Adjusted width.
         */
        $scope.calcWidth = function (width, height) {
            var maxWidth = $scope.$parent.$parent.size == 50 ? 415 : 919;
            if(width > maxWidth){
                var ratio = maxWidth / width;   // get ratio for scaling image
                width = width * ratio;    // Reset width to match scaled image
                return width;
            } else {
                return '100%';
            }
        };

        /**
         * Controller for the browse modal instance.
         * @param {Object} $scope - Angular scope.
         * @param {Object} $uibModalInstance - Instance of the UI Bootstrap modal.
         * @param {string} contentObjectUUID - UUID of the content object.
         */
        var browseModalInstanceController = function ($scope, $uibModalInstance, contentObjectUUID) {
            $scope.showonly = 'image';
            $scope.contentobjectuuid = contentObjectUUID;
            $scope.onModalCloseButtonClick = function() {
                $scope.selectImage = false;
                $uibModalInstance.dismiss('cancel');
            };
        };

        var modalInstance = null;

        /**
         * Gets the media URL based on the media object and thumbnail flag.
         * @param {Object} mediaObject - Media object.
         * @param {boolean} thumbnail - Flag indicating if thumbnail is requested.
         * @returns {string|boolean} - Media URL or false if mediaObject is not an object.
         */
        $scope.getMediaURL = function(mediaObject, thumbnail) {
            // This will determine the filename slug / extension for thumbnails
            var thumbnailSlug = '_thumb', //@TODO get thumbnailSlug and thumbnailExtension values from django settings
                thumbnailExtension = 'jpg';

            if (!angular.isObject(mediaObject)) {
                return false;
            }

            var thumbnailFlag       = angular.isDefined(thumbnail) ? thumbnail : false,
                re                  = /(?:\.([^.]+))?$/,
                uploadName          = mediaObject.getUploadName(),
                extension           = thumbnailFlag ? thumbnailExtension : re.exec(uploadName)[1],
                mimeType            = mediaObject.getMimeType(),
                fileNameSlug        = thumbnailFlag ? thumbnailSlug : "",
                fileName            = mediaObject.getUUID() + fileNameSlug + '.' + extension,
                url;

            if (mimeType == 'image/svg+xml') {
                filename = mediaObject.getUUID() + fileNameSlug + '.svg';
            }

            url = isCMS ? "/media/"+$scope.taskuuid+"/"+fileName : "/media/"+fileName;

            return url;
        };

        /**
         * Handles the click event for audio object background images button.
         */
        $scope.onAudioObjectBackgroundImagesButtonClick = function () {
            $scope.selectImage = true;
            $scope.openMediaModal('image');
        };

        /**
         * Handler for selected image (in media browser modal).
         * @param {Object} selectedMedia - Selected media object.
         */
        var onSelectMediaImage = function(selectedMedia) {
            if (selectedMedia.contentobjectuuid == $scope.contentObject.getUUID()) {
                $scope.contentObject.setAttachement(selectedMedia.uuid);
                $scope.backgroundImage = true;

                // Close modal
                if (modalInstance !== null) {
                    $scope.selectImage = false;
                    modalInstance.close();
                }
            }
        };

        /**
         * Handler for selected media.
         * @param {Object} selectedMedia - Selected media object.
         */
        var onSelectMedia = function(selectedMedia) {
            if (!$scope.selectImage) {
                if (selectedMedia.contentobjectuuid === $scope.contentObject.getUUID()) {
                    var media = TaskDataService.fetchContext().read(selectedMedia.uuid);

                    if ( media.getMimeType().indexOf('x-subrip') >= 0 ) {
                        $scope.contentObject.setContent(selectedMedia.uuid);
                    } else {
                        $scope.contentObject.setContentReference(selectedMedia.uuid);
                        $scope.hasAudioObjectBackgroundImages = true;
                    }

                    // Close modal
                    if (modalInstance !== null) {
                        modalInstance.close();
                    }
                }
            } else {
                onSelectMediaImage(selectedMedia);
            }
        };

        /**
         * Handles the click event for media add subtitle button.
         */
        $scope.onMediaAddSubtitleButtonClick = function () {
            $scope.openMediaModal('subtitle');
        };

        /**
         * Handles the click event for media delete subtitle button.
         */
        $scope.onMediaDeleteSubtitleButtonClick = function () {
            $scope.contentObject.setContent('');
            $scope.subtitle = undefined;
            $scope.removeSubtitle = false;
        };

        /**
         * Handles the click event for audio object delete background images button.
         */
        $scope.onAudioObjectDeleteBackgroundImagesButtonClick = function () {
            $scope.contentObject.setAttachement('');
            $scope.bgImage = undefined;
            $scope.removeBgImage = false;
        };

        /**
         * Opens the media modal for the specified type.
         * @param {string} type - Type of media to open the modal for.
         */
        $scope.openMediaModal = function (type) {
            modalInstance = $uibModal.open({
                templateUrl: '/views/ib/cms/eassessment/modal/eassessmentmediabrowserModal.html',
                controller: function ($scope, $uibModalInstance, $signals, TaskDataService, contentObjectUUID) {
                    $scope.showonly = type;
                    $scope.contentobjectuuid = contentObjectUUID;

                    $scope.onModalCloseButtonClick = function() {
                        $uibModalInstance.dismiss('cancel');
                    };
                },
                scope: $scope,
                resolve: {
                    'contentObjectUUID': function() {
                        return $scope.contentObject.getUUID();
                    }
                }
            });
        };

        var parentContainer = $scope.$parent.containerObj;

        /**
         * Initializes preferences for the audio object.
         */
        $scope.initPreferences = function() {
            var showSubtitleOnPlay = (typeof $scope.contentObject.getPreferences() != "undefined" ? $scope.contentObject.getPreferences().showSubtitleOnPlay : undefined);
            var includedInPDF = (typeof $scope.contentObject.getPreferences() !== "undefined" ? $scope.contentObject.getPreferences().includedInPDF : "disabled");
            var targetHintObject = (typeof $scope.contentObject.getPreferences() != "undefined" ? $scope.contentObject.getPreferences().targetHintObject : undefined);

            $scope.$watch('preferencesValues', function(val1, val2) {
                if (val1 == val2)
                    return;
                var preferences = {};
                angular.forEach($scope.preferencesValues, function(value, key) {
                    preferences[key] = value;
                });
                $scope.contentObject.setPreferences(preferences);
            }, true);

            $scope.preferencesValues = {};
            $scope.preferencesValues['showSubtitleOnPlay'] = showSubtitleOnPlay;
            $scope.preferencesValues['includedInPDF'] = typeof includedInPDF !== 'undefined' ? includedInPDF : "disabled";
            $scope.preferencesValues['targetHintObject'] = targetHintObject;

            $scope.preferences = [
                {
                    'includedInPDF': [
                        {'type': 'checkbox', 'name': 'Included in Response PDF', 'valueKey': 'includedInPDF'}
                    ],
                    'showSubtitleOnPlay': [
                        {'type': 'checkbox', 'name': 'Show subtitles on audiostart? ', 'valueKey': 'showSubtitleOnPlay'}
                    ],
                    'targetHintObject': [{
                        'type': 'select-other-content-object',
                        'name': ' link this Object as Hint',
                        'valueKey': 'targetHintObject',
                        'objectType': 'hint',
                        'parentContainer': parentContainer
                    }]
                },
            ];
        };
        $scope.initPreferences();

        // When we get destroyed, we need to unbind the signal
        $scope.$on('$destroy', function() {
            $signals.remove(IB.Signals.CMS_MEDIA_OBJECT_SELECTED, onSelectMedia);
        });

        // Bind to media selection signal (triggered by media browser modal window)
        $signals.on(IB.Signals.CMS_MEDIA_OBJECT_SELECTED, onSelectMedia);

        var _d = $q.defer();
        SheetLoadedService.wait(_d.promise, 'audio');
        $timeout(function () {
            if ($scope.$parent.element.find('iframe').length > 0) {
                $scope.$parent.element.find('iframe').load(function () {
                    _d.resolve('audio');
                });
            } else {
                _d.resolve('audio');
            }
        });
    }
}

/**
 * Registers the AsfAudioObject directive in the specified module.
 * @param {Object} module - Angular module.
 */
export default function registerAsfAudioObjectDirective(module) {
    module.directive('asfAudioObject', function() {
        return {
            restrict: 'EA',
            replace: true,
            scope: {
                "contentObject": "="
            },
            templateUrl: "/views/ib/contentobjects/audio.html",
            controller: 'AsfAudioObjectCtrl'
        };
    });

    module.controller('AsfAudioObjectCtrl', AsfAudioObjectCtrl);

    module.run(['ContentObjectRegistryService', function(ContentObjectRegistryService) {
        var obj = [{
            "uuid": "",
            "content": "",
            "objectType": "audio",
            "type": "contentObject",
            "contentReference": false,
            "preferences": {
                "showSubtitleOnPlay": false,
                "includedInPDF" : "disabled" // true, false, disabled
            }
        }];
        var objProperties = {
            type: "audio",
            label: 'CMS.LAYOUT-MANAGER.NEW-OBJECT.AUDIO.LABEL',
            cssClass: "new-audio-object",
            icon: "cms/icon-audio.png",
            description: 'CMS.LAYOUT-MANAGER.NEW-OBJECT.AUDIO.DESCRIPTION',
            group: {
                id: 2
            }
        };
        ContentObjectRegistryService.register(obj, objProperties);
    }]);
}